import { Controller } from "@hotwired/stimulus"

// AT-1113: de bestelknop pas bruikbaar zodra er tickets gekozen zijn.
//
// Zonder dit klik je op "Naar de stoelen" met alles op nul, en krijg je bovenaan de pagina
// "Je hebt nog geen tickets geselecteerd" -- een melding die je pas ziet ná een volledige
// paginalading, en die niets uitlegt wat je niet al kon zien. De knop kan dat zelf
// voorkomen.
//
// De serverkant blijft staan: zonder JS is de knop gewoon bruikbaar en vangt
// SessionCart#add het af. Staat er geen enkel tarief in het formulier, dan doet
// ShoppingCartController#update dat (AT-1360). Dit is een verbetering van de bediening, geen vervanging van de
// controle.
export default class extends Controller {
  static targets = ["submit", "amount"]

  connect() {
    this.#sync()
  }

  // Aangeroepen bij elke wijziging in het formulier: de stepper stuurt zelf een
  // change-event, en typen in het veld doet dat ook.
  sync() {
    this.#sync()
  }

  #sync() {
    if (!this.hasSubmitTarget) return

    const totaal = this.amountTargets.reduce((som, veld) => som + (parseInt(veld.value, 10) || 0), 0)
    const leeg = totaal === 0

    this.submitTarget.disabled = leeg
    this.submitTarget.classList.toggle("btn--disabled", leeg)
  }
}
